module.exports = __webpack_public_path__ + "static/media/banner.a8b3455f.jpg";